export default "__VITE_ASSET__d814fde9__"